export default __webpack_public_path__ + "static/hero-image3_6-7f4cd14e8cda4d051c9b74b8d1292073.png";